<template>
  <div>
      <div class="startConRight">
            <p>请先阅读：</p>
            <span>从此页面开始接下来12个页面均为考试说明部分，在真实的考试中包含这些页面。你可以提前了解，以便于节省真实考试时理解时间。在考满分GMAT考试系统中你可以选择右下角跳过说明按钮直接进入考试。但在真实考试中是不能跳过该部分的。</span>
            <div class="welcomeSys">
              <h1>Welcome to GMAT Test System</h1>
              <p>You are about to begin a simulation of the Graduate Management Admission Test(GMAT).</p>
              <p>When you actually sit for the exam,the following policies apply throughout the test:</p>
              <p>Before you take the exam,you will be required to agree to the GMAT Nondisclosure Agreement and GeneralTerms of Use.You can view the Nondisclosure Agreement and Test Taker Rules by visiting www.mba.com.</p>
              <p>During the GMAT exam,both audio and video may be recorded in the testing room while you take thetest.If you do not agree,you will not be allowed to complete the test.</p>
              <p>Clickto <button>Next</button> continue.</p>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  methods:{
  }
}
</script>

<style  scoped>
@import '../../../assets/css/examInstructions.css';
 
</style>


// WEBPACK FOOTER //
// src/view/examinatSystem/testExplanation/examInstructions.vue